import React, { useCallback } from 'react';
import { View } from 'react-native';
import CampImages from '../images/CampImages';
import SectionDivider from '../common/SectionDivider';
import CampPageHostList from '../hosts/CampPageHostList';
import CampPageMap from '../locations/CampPageMap';
import CampPageReviewListView from '../reviews/CampPageReviewListView';

interface CampInfoSectionProps {
    camp: any;
    setCamp: (camp: any) => void;
    canEdit: boolean;
    currentUser?: any;
    setSelectedMarker: (marker: any) => void;
    isMapLoaded?: boolean;
    mapLoadError?: Error | undefined;
    children?: React.ReactNode; // For the description section
}

const CampInfoSection: React.FC<CampInfoSectionProps> = ({
    camp,
    setCamp,
    canEdit,
    currentUser,
    setSelectedMarker,
    isMapLoaded,
    mapLoadError,
    children,
}) => {
    const handleSummaryChange = useCallback((summary: any) => {
        if (!summary) return;
        setCamp((prev: any) => {
            const nextRating = summary.averageRating || 0;
            const nextReviewCount = summary.reviewCount || 0;
            if ((prev?.rating || 0) === nextRating && (prev?.reviewCount || 0) === nextReviewCount) {
                return prev;
            }
            return {
                ...prev,
                rating: nextRating,
                reviewCount: nextReviewCount,
            };
        });
    }, [setCamp]);

    return (
        <View>
            <CampImages camp={camp} isEditing={canEdit} setCamp={setCamp} />
            <SectionDivider />

            <CampPageHostList camp={camp} setCamp={setCamp} isEditing={canEdit} />

            <SectionDivider />
            <CampPageMap
                camp={camp}
                setSelectedMarker={setSelectedMarker}
                isMapLoaded={isMapLoaded}
                mapLoadError={mapLoadError}
            />

            <SectionDivider />
            
            {/* Description Section */}
            {children}

            <SectionDivider />
            <CampPageReviewListView
                campId={camp?.campId}
                currentUser={currentUser}
                onSummaryChange={handleSummaryChange}
            />
        </View>
    );
};

export default CampInfoSection;

